import {Component} from '@angular/core';
import {Observable} from "rxjs";
import {Job} from "../../../Interfaces/job.interface";
import {RestResponse} from "../../../Interfaces/RestResponse.interface";
import RestHelper from "../../../Helper/RestHelper";
import {HttpClient} from "@angular/common/http";
import {LoaderService} from "../../../services/loader/loader.service";
import Helper from "../../../Helper/Helper";
import PermissionsHelper from "../../../Helper/PermissionsHelper";
import {Router} from "@angular/router";

@Component({
  selector: 'app-jobs',
  templateUrl: './jobs.component.html'
})
export class JobsComponent {

  constructor(private httpClient: HttpClient, protected loader: LoaderService, public router: Router) {
    this.loader.showLoader()
    this.jobs = this.getJobs()
  }

  public jobs: Observable<Job[]> | undefined
  public apierror: boolean = false


  private getJobs(sortby: string = "", sorttype: string = ""): Observable<Job[]> {

    const urlSearchParams = new URLSearchParams();

    if (sortby !== "") {
      urlSearchParams.set("sortby", sortby);
    }
    if (sorttype !== "") {
      urlSearchParams.set("sorttype", sorttype);
    }

    console.log(urlSearchParams.toString())

    return new Observable(subscriber => {

      this.httpClient.get<RestResponse<Job[]>>(RestHelper.API_BASE_URL + "job/getJobList?admin=true&" + urlSearchParams.toString(), RestHelper.requestOptions).subscribe({
        next: (value) => {
          subscriber.next(value.data)
          this.loader.hideLoader()
        }, error: () => {
          this.apierror = true
          this.loader.hideLoader()
        }
      })
    })
  }

  public recreateindexsuccess: boolean | undefined

  public recreateIndex(uuid: string | undefined = undefined) {
    this.loader.showLoader()

    const urlSearchParams = new URLSearchParams()

    if(uuid !== undefined) {
      urlSearchParams.append("uuid", uuid)
    }

    urlSearchParams.append("table", "jobs")

    this.httpClient.get<any>(RestHelper.API_BASE_URL + "rebuildIndex?" + urlSearchParams.toString(), RestHelper.requestOptions).subscribe({
      next: (value) => {

        this.loader.hideLoader()
        this.recreateindexsuccess = true
      }, error: (err) => {
        console.log(err)
        this.recreateindexsuccess = false
        this.loader.hideLoader()
      }
    })
  }

  public changePublishedStatus(event: Event, uuid: string) {

    event.preventDefault()
    event.stopPropagation();

    const input = event.target as HTMLInputElement;
    const body = new FormData();

    body.append("uuid", uuid)
    body.append("published", String(input.checked))

    this.httpClient.patch(RestHelper.API_BASE_URL + 'job/updateJob', body, RestHelper.requestOptions)
      .subscribe({
        next: () => {
          input.checked = !input.checked
        },
        error: (err) => {
          console.error(err)
        }
      });
  }

  public lastsort: string = ""
  public lastsorttype = ""

  public sortTablebyColum(property: string) {
    let sorttype: string;
    if (this.lastsort === property) {
      if (this.lastsorttype === "ASC") {
        sorttype = "DESC";
      } else {
        sorttype = "ASC"
      }
    } else {
      sorttype = "ASC"
    }
    this.lastsort = property
    this.lastsorttype = sorttype;
    this.jobs = this.getJobs(property, sorttype)
  }

  protected readonly Helper = Helper;
  protected readonly PermissionsHelper = PermissionsHelper;
}
